import * as signalR from "@aspnet/signalr";

export interface DbSubscriptionState {
    initialized: boolean;
    websocket?: signalR.HubConnection;
}

export const initialState: DbSubscriptionState = {
    initialized: false,
};



// WEBPACK FOOTER //
// ./src/store/DbSubscriptionState.ts